
import { defineComponent, computed, ref, reactive } from "vue";
import { useVuelidate } from "@vuelidate/core";
import { requiredIf, helpers } from "@vuelidate/validators";

export default defineComponent({
  name: "Test",
  setup() {
    const model = reactive({
      name: "",
      age: 1,
      confirm: false,
    });
    const submit = ref(false);
    const customRule = (value: any) => {
      return value != null && submit.value != true;
    };
    const rules = computed(() => ({
      model: {
        name: {
          // required: requiredIf(() => submit.value == true),
          required: helpers.withMessage("ERROR", customRule),
        },
      },
    }));

    const v$ = useVuelidate(rules, { model });
    const onSubmit = () => {
      submit.value = true;
      v$.value.$reset();
      v$.value.$touch();
    };
    const onSave = () => {
      submit.value = false;
      v$.value.$reset();
      v$.value.$touch();
    };
    const onReset = () => {
      v$.value.$reset();
    };
    return {
      v$,
      model,
      onSubmit,
      onSave,
      onReset,
      submit,
    };
  },
});
